import IconCalendar from "./Icons/IconCalendar";
import IconComment from "./Icons/IconComment";
import IconOpenBook from "./Icons/IconOpenBook";
import IconSettings from "./Icons/IconSettings";
import AccountItem from "./Helpers/AccountItem";
import BugReportItem from "./Helpers/BugReportItem";
import NavListItem from "./Helpers/NavListItem";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useGlobalStore } from "../../../api/globalStores";
import { useLocation } from "react-router-dom";

export interface INavigationDrawer {}

export default observer(NavigationDrawer);

function NavigationDrawer() {
  let location = useLocation();
  const globalStores = useGlobalStore();
  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectedChange = (pageName: string) => {
    setSelectedPage(pageName);
  };

  useEffect(() => {
    setSelectedPage(location.pathname.split("/").at(-1) ?? "");
  }, [location]);

  return (
    <div className="bg-brij-Mud p-6 max-w-[300px] min-w-[230px] w-full flex flex-col justify-between h-full text-brij-Default overflow-x-scroll">
      <div className="inline-flex flex-col gap-3">
        <AccountItem
          name={
            globalStores.teacherStore.staffDetail.displayName ??
            "Set Name in Settings"
          }
        />
        <NavListItem
          icon={<IconCalendar selected={selectedPage === "calendar"} />}
          text="Calendar"
          linkTo="calendar"
          handleSelectedChange={handleSelectedChange}
          selectedPage={selectedPage}
        />
        <NavListItem
          icon={<IconOpenBook selected={selectedPage === "lesson_planning"} />}
          text="Lesson Planning"
          linkTo="lesson_planning"
          handleSelectedChange={handleSelectedChange}
          selectedPage={selectedPage}
        />
        <NavListItem
          icon={<IconComment selected={selectedPage === "student_feedback"} />}
          text="Student Feedback"
          linkTo="student_feedback"
          handleSelectedChange={handleSelectedChange}
          selectedPage={selectedPage}
        />
      </div>
      <div>
        <BugReportItem />
        <NavListItem
          icon={<IconSettings selected={selectedPage === "settings"} />}
          text="Settings"
          linkTo="settings"
          handleSelectedChange={handleSelectedChange}
          selectedPage={selectedPage}
        />
      </div>
    </div>
  );
}
